import base from '../base';
import { getRequest, postJsonRequest } from '@/util/http';
// const serveName = 'reconciliation'

const RECONCILIATION = {
  // 获取对账列表
  getListByQuery(params) {
    return postJsonRequest(`${base.baseUrl}/reconciliation/getListByQuery`, params);
  },
  // 获取对账详情
  getReconciliationDetail(params) {
    return getRequest(`${base.baseUrl}/reconciliation/getById`, params);
  },
  // 重新对账
  updateReconciliation(params) {
    return postJsonRequest(`${base.baseUrl}/reconciliation/system`, params);
  },
  // 获取对账详情中差错账单
  getFailList(params) {
    return getRequest(`${base.baseUrl}/errorBill/getByBatchNumber`, params);
  },
  // 修改差错账单状态
  updateFailStatus(params) {
    return getRequest(`${base.baseUrl}/errorBill/updateState`, params);
  },
  // 获取分页差错账单
  getErrorList(params) {
    return postJsonRequest(`${base.baseUrl}/errorBill/getByQuery`, params);
  },
  // 获取差错对账详情
  getErrorDetails(params) {
    return getRequest(`${base.baseUrl}/errorBill/getById`, params);
  },
  //重新对账
  reWriteBills(params) {
    return postJsonRequest(`${base.baseUrl}/reconciliation/reWriteBills`, params);
  },
};

export default RECONCILIATION;
